// extracted by mini-css-extract-plugin
export default {"javaText":"PriceCard_javaText__OEsWA","priceText":"PriceCard_priceText__+SH+s"};